module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner12.6642eeb1.png";